import { formatPriorToDisplayName } from 'constants/condition';
import { getConditionalObject } from 'utils/data';

const PRIOR_TO_PREFIX_PATTERN = /^prior to\b/i;

/**
 * Resolves a condition's prior-to option: by `priorToTypeId` first, then — for legacy
 * conditions written before company prior-to types existed — by the standard row of its stage.
 */
export const findPriorToOption = ({ options = [], priorToTypeId, priorToType }) =>
  (priorToTypeId && options.find(({ value }) => value === priorToTypeId)) ||
  options.find(({ isStandard, stage }) => isStandard && stage === priorToType) ||
  null;

/**
 * Picker options keep the condition's current value selectable even when that type was disabled.
 */
export const getPriorToPickerOptions = ({ options, currentOption }) =>
  !currentOption || options.some(({ value }) => value === currentOption.value)
    ? options
    : [...options, currentOption];

/**
 * Request fields for a chosen option. The stage rides along as the legacy `priorToType`
 * because it always matches the row, so the server's stage-agreement check passes.
 */
export const getPriorToRequestFields = option =>
  getConditionalObject(!!option, () => ({
    priorToTypeId: option.value,
    priorToType: option.stage,
  }));

export const getPriorToDisplayName = ({ priorToTypeName, priorToType }) =>
  priorToTypeName || formatPriorToDisplayName(priorToType) || '';

export const formatPriorToHeading = (name, prefix = 'Prior to') =>
  PRIOR_TO_PREFIX_PATTERN.test(name) ? name : `${prefix} ${name}`;
